var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-page__rows" },
    [
      _c(
        "div",
        { staticClass: "flex flex-wrap row--container justify-center" },
        [
          _c("div", { staticClass: "w-12/12 md:w-6/12 text-center" }, [
            _c(
              "div",
              { staticClass: "w-full px-gap2 z-10 max-w-[600px] mx-auto" },
              [_c("Markdown", { attrs: { source: _vm.content.heroText } })],
              1
            ),
            _vm._v(" "),
            _vm.isVGBasicCustomer && _vm.activeOffer.productKey == "VG54"
              ? _c(
                  "div",
                  [
                    _c("Notice", {
                      staticClass: "notice",
                      attrs: { noticeType: "notice" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "content",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n            Your business does not currently leverage the full Vehicle Gateway functionality. Please contact your sales rep to upgrade or add-on to your fleet.\n          "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        755922626
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "mt-3 md:mt-0 md:flex justify-center items-center md:max-w-[450px] md:max-h-[62px] mx-auto md:mb-2",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "leading-tight font-bold cursor-pointer bg-blue-default text-white md:mr-2 py-1 px-2 rounded-full text-lg w-2/12 min-w-[130px] text-center",
                    class:
                      !(
                        !_vm.isENT ||
                        (_vm.isENT && _vm.activeOffer.monthlyUnitPrice)
                      ) && "md:mr-0",
                    on: {
                      click: function ($event) {
                        return _vm.handleBuyButtonClick()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.buyButtonLanguage) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.shouldCustomerSeePricing &&
                (!_vm.isENT || (_vm.isENT && _vm.activeOffer.monthlyUnitPrice))
                  ? _c("Pricing")
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.activeProductInfo.productAlert
              ? _c("div", { staticClass: "product-alert" }, [
                  _vm._v(_vm._s(_vm.activeProductInfo.productAlert)),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.content.rows, function (content, index) {
        return _c("Row", { key: index, attrs: { row: content } })
      }),
      _vm._v(" "),
      _vm.activeProductInfo.frequentlyBoughtTogether &&
      _vm.activeProductInfo.frequentlyBoughtTogether.length > 0
        ? _c(
            "div",
            { staticClass: "product-page__accessories" },
            [
              _c("FrequentlyBoughtTogether", {
                attrs: { activeProductInfo: _vm.activeProductInfo },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }